import axiosInstance from '../../../../config/axiosInstance';
const TermsConditionService = {
    async GetAllTermsCondition(redirectCallback) {
        try {
            
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetAllTermsCondition?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async CreateTermCondition(ModuleID,IsTermCondition, redirectCallback) {
        try {
            const ID=0;
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/CreateTermCondition?ID=${ID}&ClientID=${ClientID}&ModuleID=${ModuleID}&IsTermCondition=${IsTermCondition}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetByModuleID(ModuleID,redirectCallback) {
        try {
            
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetByModuleID?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
};

export default TermsConditionService;